import React, { Component } from "react";

import arrowBlue from "../../../../img/landing-page/arrow-blue.svg"
import arrowYellow from "../../../../img/landing-page/arrow-yellow.svg"

class LandingPageHowToProfitWidget extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showAbout: false
		};
	}

	handleChangeViewMode = () => {
		this.setState({
			showAbout: !this.state.showAbout
		});
	};

	render() {
		const { number, title, subtitle, icon, aboutText } = this.props;
		const { showAbout } = this.state;

		return (
			<div
				onClick={() => this.handleChangeViewMode()}
				className={`offers-landing-page-how-to-profit-widget ${
					showAbout ? "offers-landing-page-how-to-profit-widget__about" : ""
				}`}
			>
				<div className="offers-landing-page-how-to-profit-widget--bg-number">{number}</div>
				<div className="offers-landing-page-how-to-profit-widget__content">
					{!showAbout ? (
						<div className="offers-landing-page-how-to-profit-widget__content--front">
							<img alt="" src={icon} />
							<div className="offers-landing-page-how-to-profit-widget__content--front--text">
								<strong>{title}</strong>
							</div>
						</div>
					) : (
						<div>
                            { aboutText }
                        </div>
					)}
				</div>
				<div className="offers-landing-page-how-to-profit-widget--triangle" />
				<img className="offers-landing-page-how-to-profit-widget--arrow" src={!this.state.showAbout ? arrowBlue : arrowYellow} alt="" />
			</div>
		);
	}
}

export default LandingPageHowToProfitWidget;
